import Floor from "../Floor.js";
import NavigatorRouter from "@modules/navigator/Navigator.router.js";

const FloorSelect = {

    init() {
        this.el = $('[component="FloorSelect"]');
        if (!this.el.length) return;

        this.select = this.el.find('select');
        this.max = parseInt(this.select.find('option').last().val());
        this.min = parseInt(this.select.find('option').first().val());
        this.nav = this.el.find('.nav');

        this.bind();
        this.arrangeButtons();
    },

    bind() {
        this.select.off('change').change(function (evt) {
            const number = parseInt($(evt.target).val());
            const direction = Math.sign(number - Floor.number);
            Floor.number = number;
            FloorSelect.set(number, direction);
        })

        this.nav.find("button").off('click').click(function (evt) {
            const direction = parseInt($(this).attr('direction'));

            FloorSelect.shift(direction);
            FloorSelect.set(Floor.number, direction);
            // FloorSelect.select.trigger("change");
        })
    },

    update(nmb) {
        this.select.val(nmb);
        this.arrangeButtons();
    },

    set(nmb, direction) {
        if(this.debug) console.log('set', nmb, direction)
        NavigatorRouter.setFloor(nmb, direction);
        this.arrangeButtons();
    },

    shift(direction) {
        Floor.number = Floor.number + direction;

        if (Floor.number < this.min) {
            Floor.number = this.min;
        }
        if (Floor.number > this.max) {
            Floor.number = this.max;
        }

        this.arrangeButtons();
    },

    arrangeButtons() {
        this.nav.removeClass('start end');

        if (Floor.number >= this.max) {
            this.nav.addClass('end');
        }
        if (Floor.number <= this.min) {
            this.nav.addClass('start');
        }
    },
}
export default FloorSelect;